// @flow

import React from 'react'
import styled from 'styled-components'
import { Radio } from 'antd'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'

const List = styled.ul`
  ${mediaMin.phone`
    margin: 0 -4px;
  `};
`
const ListItem = styled.li`
  display: inline-block;
  width: 100%;
  vertical-align: top;

  &:not(:first-of-type) {
    margin-top: ${spacing.medium__15}px;
  }

  ${mediaMin.phone`
    width: 33.333%;
    padding: 0 4px;
    &:not(:first-of-type) {
      margin-top: 0;
    }
    &:not(:nth-child(-n+3)) {
      margin-top: ${spacing.medium_2}px;
    }
  `};
`
const FullList = styled.ul``

const FullListItem = styled.li`
  &:not(:first-of-type) {
    margin-top: ${spacing.medium__15}px;
    ${mediaMin.phone`
      margin-top: ${spacing.medium_2}px;
    `};
  }
`
const Footer = styled.p`
  display: block;
  margin-top: ${spacing.small_2}px;
  font-size: ${fontSize.small_3}px;
  line-height: 1.363;
`

function getSelectedContainer(widthType) {
  switch (widthType) {
    case 'full':
      return FullList
    default:
      return List
  }
}
function getSelectedWrapper(widthType) {
  switch (widthType) {
    case 'full':
      return FullListItem
    default:
      return ListItem
  }
}

export type PropTypes = {
  radioList: Array<{
    label: string,
    value: number | string,
    footer?: string,
  }>,
  name: string,
  selectedValue?: ?number | string,
  onChange: Function,
  bold?: boolean,
  widthType?: ?string,
}

const RadioGroup = Radio.Group

export default function CheckboxList(props: PropTypes) {
  const { widthType, radioList } = props
  const SelectedContainer = getSelectedContainer(widthType)
  const SelectedWrapper = getSelectedWrapper(widthType)

  return (
    <SelectedContainer widthType={widthType}>
      <RadioGroup
        onChange={e => props.onChange(e.target.value)}
        value={props.selectedValue}
      >
        {radioList.map((radio, index) => (
          <SelectedWrapper key={index} bold={props.bold} widthType={widthType}>
            <Radio value={radio.value} name={props.name}>
              {radio.label}
              {radio.footer && <Footer>{radio.footer}</Footer>}
            </Radio>
          </SelectedWrapper>
        ))}
      </RadioGroup>
    </SelectedContainer>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/RadioList/index.jsx